import { render, staticRenderFns } from "./detailComplaint.vue?vue&type=template&id=0685fbf8&"
import script from "./detailComplaint.vue?vue&type=script&lang=js&"
export * from "./detailComplaint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports